import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const MODAL_KEY = 'indication_modal_shown_once';

export const useIndicationModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    const alreadyShown = localStorage.getItem(MODAL_KEY);
    const leftRootPath = previousPath.current === '/' && location.pathname !== '/';

    if (leftRootPath && !alreadyShown) {
      setIsOpen(true);
      localStorage.setItem(MODAL_KEY, 'true');
    }

    previousPath.current = location.pathname;
  }, [location.pathname]);

  return { isOpen, setIsOpen };
};
